import React from "react";
import Postform from "./postform.js"; 
function App() {
  return (
    <div>
      <Postform/>
    </div>
  );
}

export default App;
